module.exports = __webpack_public_path__ + "static/3_QUEEN-9a4e16355959b0a25868f5519b7af81c.png";